import {
    Globe,
    ShoppingBag,
    Plane,
    Coffee,
    Car,
    UserSquare2,
    Search,
    Wrench,
} from "lucide-react";

const services = [
    {
        n: "01",
        title: "Website Profil Usaha",
        desc: "Tampilkan kredibilitas bisnis dengan halaman profil yang elegan, ringkas, dan mudah ditemukan di Google.",
        icon: Globe,
        tone: "ochre",
    },
    {
        n: "02",
        title: "Toko Online",
        desc: "Katalog, keranjang, dan checkout via WhatsApp atau payment gateway.",
        icon: ShoppingBag,
        tone: "cream",
    },
    {
        n: "03",
        title: "Tour & Travel · Haji Umroh",
        desc: "Sistem paket, jadwal keberangkatan, dan formulir pendaftaran jamaah.",
        icon: Plane,
        tone: "green",
    },
    {
        n: "04",
        title: "Showroom + Admin Panel",
        desc: "Mobil bekas atau properti, dengan panel admin agar update stok jadi cepat.",
        icon: Car,
        tone: "primary",
    },
    {
        n: "05",
        title: "Website Cafe & Resto",
        desc: "Menu digital, reservasi, dan integrasi peta lokasi yang menggugah.",
        icon: Coffee,
        tone: "cream",
    },
    {
        n: "06",
        title: "Profil Personal",
        desc: "Untuk dosen, dokter, konsultan, atau personal branding profesional.",
        icon: UserSquare2,
        tone: "cream",
    },
    {
        n: "07",
        title: "SEO & Google Business",
        desc: "Bantu usaha anda muncul saat pelanggan mencari di Jayapura.",
        icon: Search,
        tone: "cream",
    },
    {
        n: "08",
        title: "Maintenance & Hosting",
        desc: "Backup rutin, update keamanan, dan support cepat saat dibutuhkan.",
        icon: Wrench,
        tone: "cream",
    },
];

const toneClass = {
    cream: "bg-jws-surface text-jws-text",
    ochre: "bg-jws-ochre text-jws-text",
    green: "bg-jws-secondary text-jws-bg",
    primary: "bg-jws-primary text-jws-bg",
};

export const Services = () => {
    return (
        <section
            id="layanan"
            data-testid="services-section"
            className="py-20 md:py-32 relative"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-5">
                        <div className="text-xs uppercase tracking-[0.3em] text-jws-muted mb-4">
                            (01) Layanan
                        </div>
                        <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[1]">
                            Bukan template.
                            <br />
                            Dibuat sesuai{" "}
                            <span className="italic text-jws-primary">
                                kebutuhan
                            </span>{" "}
                            usaha anda.
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-5 md:col-start-8 md:pt-6">
                        <p className="text-lg text-jws-muted leading-relaxed">
                            Setiap proyek dimulai dengan obrolan ringan tentang
                            target pelanggan, masalah yang ingin diselesaikan,
                            dan bagaimana website bisa benar-benar menambah
                            penjualan — bukan sekadar “punya website”.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                    {services.map((s) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={s.n}
                                data-testid={`service-card-${s.n}`}
                                className={`relative ${toneClass[s.tone]} rounded-2xl p-7 md:p-8 border border-jws-border overflow-hidden flex flex-col min-h-[260px] transition-all hover:-translate-y-1 hover:shadow-xl`}
                            >
                                <div className="flex items-center justify-between text-xs tracking-[0.2em] opacity-70">
                                    <span>{s.n}</span>
                                    <Icon className="h-5 w-5" />
                                </div>
                                <h3 className="mt-auto pt-10 font-display text-2xl tracking-tight leading-[1.1]">
                                    {s.title}
                                </h3>
                                <p
                                    className={`mt-3 text-sm ${s.tone === "cream" ? "text-jws-muted" : "opacity-90"} leading-relaxed`}
                                >
                                    {s.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
